import { useLocation, useNavigate, useParams } from "react-router-dom";

export function useRouter() {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();

  return {
    location, // same as props.location
    match: { params }, // mimic old match object
    history: {
      // mimic old history object
      push: (path) => navigate(path),
      replace: (path) => navigate(path, { replace: true }),
      goBack: () => navigate(-1),
    },
  };
}
